import React, { memo } from 'react'
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Collapse } from 'antd';
import {apiDomain} from '../../setting' 
import { getCurrentLang } from '../core/BXHeader/config/commonUtil';
const PromotionRewards = memo(() => {
    const { t } = useTranslation(); 
    console.log(getCurrentLang()==='en' ,'11111111111111');
    const items=[
        {
            key: '1',
            label:<PTitle>{t('translation:promotionAward.title2')} {t('translation:promotionAward.tnc')}</PTitle>,
            children:<ChildContainer> <ul>
            <li>{t('translation:promotionAward.tnc1')}</li>
            <li>{t('translation:promotionAward.tnc2')}</li>
            <li dangerouslySetInnerHTML={{
                __html:t('translation:promotionAward.tnc3',{
                    url: apiDomain + "/pre-assessment-service/" + getCurrentLang() ,
                  })
             }}/>
            <li>{t('translation:promotionAward.tnc4')}</li>
            <li>{t('translation:promotionAward.tnc5')}</li>
            <li>{t('translation:promotionAward.tnc6')}</li>
            <li>{t('translation:promotionAward.tnc7')}</li>
            <li>{t('translation:promotionAward.tnc8')}</li>
            <li>{t('translation:promotionAward.tnc9')}</li>
        </ul> 
        </ChildContainer>,
        },
    ]
  return (
    <PromotionRewardsContainer id="PromotionRewardsContainer">
        <Collapse defaultActiveKey={['1']} ghost items={items} />
    </PromotionRewardsContainer>
  )
})
const PromotionRewardsContainer = styled.div` 
  background:#fbfbfb;
  font-size:12px; 
  color:rgb(133, 133, 133); 
  width:100%;
`
const PTitle=styled.div`
  color:rgb(0, 86, 151); 
  line-height:2;
  font-size:12px; 
 `
const ChildContainer =styled.div`
  color:rgb(133, 133, 133); 
  font-size:12px;
`
export default PromotionRewards